import api from "./api";

export const listMedia = async (params?: any) => {
    const { data } = await api.get('products/media/', { params: params });

    return data
}

export const detailMedia = async (id: string) => {
    const { data } = await api.get('products/media/' + id);

    return data
}

export const requestMediaLink = async (id: string) => {
    const { data } = await api.post('products/management/' + id + '/link/');
    return data
}

export const getMediaCategoryList = async () => {
    const { data } = await api.get('products/media_category/');
    return data
}

// Manarger Services
export const detailMediaManager = async (id: string) => {
    const { data } = await api.get('manager/media/' + id);

    return data
}

export const getAvailableItemManager = async () => {
    const { data } = await api.get('manager/item/medias_available/');
    return data
}

export const uploadMediaFile = async (id: any, params: any) => {
    let formData = new FormData();
    for (var key in params) {
        formData.append(key, params[key]);
    }

    const { data } = await api.post('manager/media/' + id + '/upload_file', params);
    return data
}

export const s3UploadFile = async (tmp_url: any, file: any, format: any) => {
    const blob = new Blob([ file ])

    const { data } = await api.put(tmp_url, blob, {
        headers: {
            'Content-Type': format,
        },
    });
    return data
}

export const completeMediaUpload = async(id: any) => { 
    const { data } = await api.patch('manager/media/' + id +'/complete_upload_file')

    return data
}

export const unzipMedia = async(id: any) => { 
    const { data } = await api.get('products/media/' + id +'/unzip')

    return data
}

export const zipStatusMedia = async(id: any) => { 
    const { data } = await api.get('products/unzip_status/' + id)

    return data
}